<template>
  <Modal
    small
    @close="rootStore.toggleLanguageSwitcher()">
    <template #modal-header>
      <h3>
        {{ $t('general/pick-a-language') }}
      </h3>
    </template>

    <ul class="striped clickable">
      <li
        v-for="lang in languages"
        :key="lang"
        @click="setLanguage(lang)">
        {{ fullName(lang) }}

        <div class="right">
          <img
            width="30"
            height="22.5"
            :src="imagePath(lang)"
            :alt="lang">
        </div>
      </li>
    </ul>
  </Modal>
</template>

<script setup>
const rootStore = useRootStore()
const langCookie = useCookie('lang')
const languages = computed(() => {
  return rootStore.languages
})
const imagePath = lang => {
  return '/flags/' + (lang === 'en' ? 'eu' : lang) + '.svg'
}
const setLanguage = lang => {
  rootStore.setLanguage(lang)

  const hreflang = document.querySelector(`[hreflang="${lang}"]`)
  if (hreflang) {
    const url = new URL(hreflang.getAttribute('href'))

    if (url) {
      window.location = url.pathname
      return
    }
  }
  langCookie.value = lang
  window.location = `/${lang}`
}
const fullName = lang => {
  if (lang === 'nl') { return 'Nederlands' }
  if (lang === 'de') { return 'Deutsch' }
  if (lang === 'en') { return 'English' }
}
</script>

<style lang="scss" module>
.image {
    height: auto;
    cursor: pointer;
    margin: $spacing * 0.5 0;
    width: $spacing * 3;
  }

</style>
